import posthog from 'posthog-js';

/**
 * Non-reactive flag read, for code outside the React tree.
 *
 * Prefer `useFeatureFlagEnabled` in components — it re-renders when the value resolves.
 * This exists for repository/service code that runs in response to a user action (a save,
 * a Load Last capture) rather than on render, where there is nothing to re-render and the
 * value is only needed at the moment the action fires.
 *
 * Reads the same singleton the provider configures, so `bootstrap.featureFlags` — and with
 * it {@link getE2eFeatureFlagOverrides} — applies here too.
 *
 * Defaults to `false`: before PostHog resolves flags (and in any environment where it never
 * loads at all) callers get the flag-off branch, which must always be the pre-feature
 * behaviour. Never use this to gate a server-side boundary.
 */
export function isFeatureFlagEnabled(flag: string): boolean {
  try {
    return posthog.isFeatureEnabled(flag) ?? false;
  } catch {
    return false;
  }
}
